import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { DescribeChannelMembershipForAppInstanceUserResponseFilterSensitiveLog, } from "../models/models_0";
import { de_DescribeChannelMembershipForAppInstanceUserCommand, se_DescribeChannelMembershipForAppInstanceUserCommand, } from "../protocols/Aws_restJson1";
export { $Command };
export class DescribeChannelMembershipForAppInstanceUserCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "DescribeChannelMembershipForAppInstanceUser", {})
    .n("ChimeSDKMessagingClient", "DescribeChannelMembershipForAppInstanceUserCommand")
    .f(void 0, DescribeChannelMembershipForAppInstanceUserResponseFilterSensitiveLog)
    .ser(se_DescribeChannelMembershipForAppInstanceUserCommand)
    .de(de_DescribeChannelMembershipForAppInstanceUserCommand)
    .build() {
}
